import React, { useEffect } from 'react';
import { Dialog, Flex, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { GridLoader } from 'react-spinners';
import I18N from '@leverege/i18n';
import S from './ResendPasswordLoading.css';
const {
  t
} = I18N.ns('userManagement.user.Loading');
export default function Loading(props) {
  const {
    message = t('message'),
    onClose,
    show,
    titleVariant = 'loadingMessage|dialogTitle',
    promise
  } = props;
  const Loader = Config.get('LoadingScreen', 'spinner', GridLoader);
  const loaderProps = Config.get('LoadingScreen', 'props', {});
  const {
    size = loaderProps.size || 30,
    color
  } = props;
  useEffect(() => {
    promise.then(() => {
      onClose();
    }).catch(err => {
      onClose();
    });
  }, []);
  return /*#__PURE__*/React.createElement(Dialog, {
    className: S.dialog,
    animation: "fade",
    variant: "resendLoading|pairing",
    show: show,
    onClose: () => {}
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    justify: "center",
    align: "center",
    style: {
      height: 200,
      width: 200
    }
  }, /*#__PURE__*/React.createElement(Text, {
    variant: titleVariant
  }, message), /*#__PURE__*/React.createElement(Loader, {
    size: size,
    color: color || 'var( --color-loader, var( --color-brand200, #dedede ) )'
  })));
}